<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('user.export_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <div class="flex">
            <div class="w-full">
                <ui-label data-cy="admin-list-manager-export-comapany-label">
                    {{ $t('user.forms.main.company_id') }}
                </ui-label>
                <a-select
                    data-cy="user-export-company-select"
                    :placeholder="$t('user.forms.main.company_id')"
                    class="mt-2"
                    show-search
                    style="width: 100%"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    @change="handleCompanyFilterChange"
                    :disabled="export_all_association"
                    :allowClear="true"
                >
                    <a-select-option v-for="(value, index) in companyList" :key="index" :value="index">
                        {{ value.company_name }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <ui-checkbox data-cy="user-export-all-by-association-select" class="mt-2" v-model="export_all_association">
            {{ $t('user.export_modal.export_all') }}
        </ui-checkbox>
        <template #footer>
            <a-button
                data-cy="user-export-submit"
                key="submit"
                type="primary"
                :disabled="company_id == undefined && export_all_association == null"
                :loading="processing"
                @click="handleSubmit"
            >
                {{ $t('user.export_modal.export') }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';
import UiSelect from '@/components/ui/Select.vue';
import UiCheckbox from '@/components/ui/Checkbox.vue';

export default {
    components: { UiLabel, UiSelect, UiCheckbox },
    data() {
        return {
            export_all_association: null,
            company_id: undefined,
            modal_visible: false,
            companyList: [],
        };
    },
    mounted() {
        if (this.is_association_section) {
            this.$http
                .get('/api/admin/list-companies', {
                    params: {
                        association_id: this.$store.getters['user/currentAssociationId'],
                    },
                })
                .then((response) => {
                    this.companyList = response.data.data;
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVUCL01' }),
                    });
                });
        } else if (this.is_admin_section) {
            this.$http
                .get('/api/admin/list-companies-by-associations')
                .then((response) => {
                    let company_list = response.data.data;

                    _.each(company_list, function (item, key) {
                        item.company_name = item.association_code + ' - ' + item.company_name;
                        company_list[key] = item;
                    });

                    this.companyList = company_list;
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVUCAL02' }),
                    });
                });
        }
    },
    props: {
        is_association_section: {
            type: Boolean,
            default: false,
        },
        is_admin_section: {
            type: Boolean,
            default: false,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        association_id: {
            type: String,
            default: '',
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        hideModal() {
            this.modal_visible = false;
        },
        handleSubmit() {
            let association_id = null;
            let company_id = this.company_id;

            if (this.export_all_association) {
                association_id = this.association_id;
                company_id = null;
            }

            this.$emit('formSubmit', {
                type: 'modal',
                association_id: association_id,
                company_id: company_id,
            });
        },
        handleCompanyFilterChange(value) {
            this.company_id = null;

            if (value != undefined) {
                this.company_id = this.companyList[value].company_id;
            }
        },
        filterOption(input, option) {
            return option.children()[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
    },
};
</script>
